<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Filter Dashboard Updates
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Search">
              <b-input name="search_text" v-model="searchText" required>
              </b-input>
            </b-field>
            <b-field label="from">
              <b-datepicker
                name="from_date"
                required
                v-model="fromDate"
                icon="calendar-today"
                trap-focus
              >
                <b-button type="is-danger" @click="fromDate = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
            <b-field label="to">
              <b-datepicker
                name="to_date"
                required
                v-model="toDate"
                icon="calendar-today"
                trap-focus
              >
                <b-button type="is-danger" @click="toDate = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </b-button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-primary" @click="submit">
          Apply
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
// @group Dashboard
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      workflow_status: null,
      isModalActive: false,
      searchText: "",
      fromDate: null,
      toDate: null
    };
  },
  methods: {
    submit() {
      this.$emit("confirm", this.searchText, this.fromDate, this.toDate);
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newVal) {
      this.isModalActive = newVal;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
